import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import Seo from "../../components/Seo";
import { PageHeader } from "../../components/lawyer/LawyerUi";
import { apiErrorMessage, lawyerService } from "../../services/lawyerApi";

const WHATSAPP_URL = "https://wa.me/971565556294";

const LawyerContact = () => {
  const { profile } = useOutletContext();
  const navigate = useNavigate();
  const [name, setName] = useState(profile?.name || "");
  const [email, setEmail] = useState(profile?.email || "");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return toast.error("Full name is required.");
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) return toast.error("Enter a valid email address.");
    if (!message.trim()) return toast.error("Please write your message.");
    setSending(true);
    try {
      const res = await lawyerService.contactUs({
        name: name.trim(),
        email: email.trim(),
        phone: profile?.phone || "",
        message: message.trim(),
      });
      if (!res?.data?.status) throw new Error(res?.data?.message);
      toast.success(res.data.message || "Thank you for contacting us.");
      navigate("/lawyer/settings");
    } catch (err) {
      toast.error(apiErrorMessage(err, err?.message || "Unable to send your message. Please try again."));
    } finally {
      setSending(false);
    }
    return undefined;
  };

  return (
    <div className="lwp-page lwp-page-narrow">
      <Seo title="Contact Us | Legal Platform" noindex />
      <PageHeader
        title="Contact Us"
        backTo="/lawyer/settings"
        actions={
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="lwp-head-btn lwp-whatsapp" aria-label="Chat on WhatsApp" title="Chat on WhatsApp">
            <i className="bi bi-whatsapp" />
          </a>
        }
      />

      <form className="lwp-form lwp-contact-form" onSubmit={submit}>
        <input
          className="lwp-input lwp-contact-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Full Name*"
          aria-label="Full name"
          autoComplete="name"
        />
        <input
          className="lwp-input lwp-contact-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email*"
          aria-label="Email"
          autoComplete="email"
        />
        <textarea
          className="lwp-textarea lwp-contact-textarea"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Your Message*"
          aria-label="Your message"
          rows={5}
        />
        <button type="submit" className="lwp-btn lwp-contact-submit" disabled={sending}>
          {sending ? <span className="spinner-border spinner-border-sm" /> : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default LawyerContact;
